import { distanceInWordsToNow } from 'date-fns';
import React, { useContext } from 'react';
import { useQuery } from 'react-apollo-hooks';
import { NotebookContext } from '../../context/NotebookContext';
import { mostRecentNoteQuery } from '../../queries/notes';
import {
  MostRecentNoteQuery,
  MostRecentNoteQueryVariables
} from '../../queries/__generated__/MostRecentNoteQuery';
import { LastEntryTimeProps } from './types';

const LastEntryTime: React.FC<LastEntryTimeProps> = ({ item }) => {
  const { notebook } = useContext(NotebookContext);
  const isEmptyGroup = !!item.subjects && item.subjects.length === 0;

  let subjectIds: string[];
  if (item.type === 'GROUP') {
    const subjects = item.subjects;
    subjectIds = subjects && subjects.length > 0 ? subjects.map(s => s.id) : [];
  } else {
    subjectIds = [item.id];
  }

  const { data, loading } = useQuery<MostRecentNoteQuery, MostRecentNoteQueryVariables>(
    mostRecentNoteQuery,
    {
      variables: {
        input: {
          notebookId: notebook.id,
          subjectIds,
          first: 1
        }
      }
    }
  );

  if (loading) return <div />;

  let lastNote;
  if (data!.notes!.edges!.length > 0 && data!.notes!.edges![0]) {
    lastNote = data!.notes!.edges![0]!.node!;
  }

  return (
    <div className="mb4-ns">
      {isEmptyGroup}
      {!!lastNote && !isEmptyGroup && (
        <p className="f8 moon-gray mv0">tracked {distanceInWordsToNow(lastNote.notedAt)} ago</p>
      )}
    </div>
  );
};

export default LastEntryTime;
